import { render, staticRenderFns } from "./ConfirmCreateCStoPO.vue?vue&type=template&id=b4bbbd72&"
import script from "./ConfirmCreateCStoPO.vue?vue&type=script&lang=js&"
export * from "./ConfirmCreateCStoPO.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCreateCStoPO.vue?vue&type=style&index=0&id=b4bbbd72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports